import React from "react"

const ModalUnderlay = ({ children }) => (
  <div>
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.42)",
        zIndex: 1
      }}
    />
    <div style={{ zIndex: 2, position: "relative" }}>{children}</div>
  </div>
)

export default ModalUnderlay
